module.exports = __webpack_public_path__ + "static/img/zkjy-icon.8cbcee68.png";